const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || 'http://localhost:8000';
export const API = `${BACKEND_URL}/api`;
export const BACKEND_URL_EXPORT = BACKEND_URL;
export { BACKEND_URL as BACKEND_URL };
export default BACKEND_URL;